import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to element matching location.hash on route change; otherwise scrolls to top.
export default function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, "");
      // Give the target route a tick to render, then scroll.
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else {
          window.scrollTo({ top: 0, behavior: "instant" });
        }
      };
      // Two rAFs handle both same-page hash changes and cross-route navigation.
      requestAnimationFrame(() => requestAnimationFrame(scroll));
    } else {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}
